export default {
  path: '/index',
  title: '首页',
  header: 'home',
  icon: 'md-speedometer',
  auth: ['hidden']
};